import { useEffect, useState } from 'react';
import { Check, Loader2 } from 'lucide-react';

const STEPS = [
  'Validando dados confirmados',
  'Agrupando por Contexto do Ambiente',
  'Agrupando por Prioridade e Postura',
  'Calculando percentuais e listas',
  'Montando os gráficos',
];

export function ProcessingStatus({ fileName }: { fileName: string }): JSX.Element {
  const [step, setStep] = useState(0);

  useEffect(() => {
    const timer = setInterval(() => setStep((value) => Math.min(value + 1, STEPS.length - 1)), 420);
    return () => clearInterval(timer);
  }, []);

  return (
    <section className="card mx-auto max-w-xl p-8 text-center">
      <Loader2 className="mx-auto h-10 w-10 animate-spin text-brand-red" aria-hidden />
      <h2 className="mt-5 text-xl font-semibold text-brand-ink">Processando os dados confirmados</h2>
      <p className="mt-1 text-sm text-brand-slate">{fileName}</p>

      <ol className="mt-6 space-y-2 text-left text-sm" aria-live="polite">
        {STEPS.map((label, index) => {
          const done = index < step;
          const active = index === step;
          return (
            <li
              key={label}
              className={[
                'flex items-center gap-3 rounded-xl px-4 py-2.5',
                active ? 'bg-brand-mist text-brand-ink' : done ? 'text-state-positive' : 'text-brand-slate',
              ].join(' ')}
            >
              {done ? (
                <Check className="h-4 w-4" aria-hidden />
              ) : active ? (
                <Loader2 className="h-4 w-4 animate-spin" aria-hidden />
              ) : (
                <span className="h-4 w-4 rounded-full border border-brand-line" aria-hidden />
              )}
              {label}
            </li>
          );
        })}
      </ol>
    </section>
  );
}
